// extracted by mini-css-extract-plugin
export default {"breadcrumbs_block":"Breadcrumbs_breadcrumbs_block__iby3T","breadcrumbs_item":"Breadcrumbs_breadcrumbs_item__qavgk","last_crumb":"Breadcrumbs_last_crumb__P1-xg"};